import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import './ReactToastify.css' // IMPORT DIRECTLY HERE , IF IMPORTED FROM NODE_MODULES DOESNT GET ADDED IN WIDGET BUILD
import './semantic.css' // IMPORT DIRECTLY HERE , IF IMPORTED FROM NODE_MODULES DOESNT GET ADDED IN WIDGET BUILD
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import { logToConsole } from './utils'
import * as Sentry from '@sentry/react'
import { ErrorBoundary } from 'react-error-boundary'

Sentry.init({
  environment: `${process.env.REACT_APP_API_ENV}`,
  dsn: 'https://5aee6b8f6d9ae09bcca2ecfca9327096@o4506626638086144.ingest.sentry.io/4506626640904192',
  integrations: [
    new Sentry.BrowserTracing(),
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  beforeSend(event) {
    logToConsole('Sendgrid beforeSend =>', event)

    let isMayaEventTarget = false
    if (event?.extra && event?.extra?.arguments && event?.extra?.arguments) {
      try {
        if (
          /* @ts-ignore */
          event.extra.arguments[0].currentTarget.includes(
            'div#maya-b2b-full-page'
          )
        ) {
          isMayaEventTarget = true
        }
      } catch (err) {
        logToConsole('Error checking isMayaEventTarget', err)
      }
    }

    // Only send events that have the 'from_maya_widget' tag set to true
    if (event.tags && event.tags.from_maya_widget === 'true') {
      logToConsole('Sending sentry event tags => from_maya_widget')
      return event // Send the event to Sentry
    } else if (isMayaEventTarget) {
      // Event target div is maya-b2b-full-page
      logToConsole(
        'Sending sentry event matching div => div#maya-b2b-full-page'
      )
      return event // Send the event to Sentry
    }

    return null // Ignore the event if it doesn't match
  },
  // Performance Monitoring
  tracesSampleRate: 0.01, //  Capture 1% of the transactions
  enabled:
    process.env.REACT_APP_API_ENV !== 'dev' &&
    process.env.REACT_APP_API_ENV !== 'staging' &&
    process.env.REACT_APP_API_ENV !== 'production',
})

const logError = (error: Error, info: { componentStack: string }) => {
  // SET SCOPE IN ORDER TO FILTER BEFORE SENDING EVENT
  Sentry.withScope(scope => {
    scope.setTag('from_maya_widget', 'true') // ADD CUSTOM MAYA WIDGET TAG TO ERROR
    Sentry.captureException(error, { extra: info })
  })
}

// FOR SEARCH
// const element = document.querySelector(
//   '#maya-b2b-full-page[data-widget-mode="search"]'
// )

// FOR CHAT
// const element = document.querySelector(
//   '#maya-b2b-full-page[data-widget-mode="full-page"], #maya-b2b-full-page[data-widget-mode="popover"]'
// )

const element = document.querySelector(process.env.REACT_APP_BUILD_TYPE || '')
if (!element) {
  console.log('Maya div not found => maya-b2b-full-page')
}
const root = ReactDOM.createRoot(element as HTMLElement)
/* @ts-ignore */
logToConsole('root is ', root._internalRoot.containerInfo.dataset)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ErrorBoundary fallback={null} onError={logError}>
          <App
            /* @ts-ignore */
            organizationKey={
              /* @ts-ignore */
              root._internalRoot.containerInfo.dataset.organizationKey
            }
            /* @ts-ignore */
            organizationSlug={
              /* @ts-ignore */
              root._internalRoot.containerInfo.dataset.organizationSlug
            }
            /* @ts-ignore */
            language={
              /* @ts-ignore */
              root._internalRoot.containerInfo.dataset.language
            }
            /* @ts-ignore */
            widgetMode={
              /* @ts-ignore */
              root._internalRoot.containerInfo.dataset.widgetMode
            }
            /* @ts-ignore */
            chatMode={
              /* @ts-ignore */
              root._internalRoot.containerInfo.dataset.chatMode
            }
            /* @ts-ignore */
            usageMode={
              /* @ts-ignore */
              root._internalRoot.containerInfo.dataset.usageMode
            }
            /* @ts-ignore */
            brand={
              /* @ts-ignore */
              root._internalRoot.containerInfo.dataset.brand
            }
          />
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
